import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { cc } from "../../../../lib/utils.js";
const numberFieldVariants = tv({
  base: `
    border rounded-md transition-[background-color,border-color,color,box-shadow]
    ${cc(
    /* 定义禁用时的状态 */
  )}
    has-[input:disabled]:bg-(--gray-tag-1-alpha) has-[input:disabled]:pointer-events-none has-[input:disabled]:cursor-not-allowed
    has-[input:read-only]:bg-(--gray-tag-1-alpha)
    ${cc(
    /* 定义focus时的颜色 */
  )}
    has-[input:focus]:border-(--border-3-alpha) has-[input:focus]:ring-(--border-1-alpha) has-[input:focus]:ring-[1px]    
    ${cc(
    /* 定义错误时的颜色 */
  )}
    has-[input[aria-invalid=true]]:border-(--red-6-alpha) has-[input[aria-invalid=true]:focus]:ring-(--red-3-alpha)
  `,
  variants: {
    size: {
      sm: "h-6",
      default: "h-9",
      lg: "h-10"
    },
    variant: {
      default: "bg-(--white) border-(--gray-tag-3-alpha)",
      filled: "bg-(--tag-1-alpha) border-transparent has-[input:focus]:bg-(--tag-3-alpha) has-[input[aria-invalid=true]]:bg-(--red-3-alpha)"
    }
  },
  defaultVariants: {
    size: "default",
    variant: "default"
  }
}), numberFieldContentVariants = tv({
  base: "flex w-full h-full text-(--gray-text-2)",
  variants: {
    size: {
      sm: "gap-1 px-1",
      default: "gap-2 px-2",
      lg: "gap-2 px-2"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), numberFieldInputVariants = tv({
  base: "grow min-w-0 text-center border-none outline-none selection:bg-(--primary-2) selection:text-(--pure-white) placeholder:text-(--gray-primary-1-alpha)",
  variants: {
    size: {
      sm: "text-sm",
      default: "text-base",
      lg: "text-lg"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), numberFieldButtonVariants = tv({
  slots: {
    button: "shrink-0 p-0 h-full text-center disabled:cursor-not-allowed text-(--gray-text-2) disabled:text-(--gray-primary-1-alpha)",
    icon: "mx-auto"
  },
  variants: {
    size: {
      sm: { button: "w-6", icon: "size-3.5" },
      default: { button: "w-9", icon: "size-4" },
      lg: { button: "w-10", icon: "size-4.5" }
    },
    side: {
      start: {},
      end: {}
    }
  },
  compoundVariants: [
    { size: "sm", side: "start", class: { button: "-ms-1" } },
    { size: ["default", "lg"], side: "start", class: { button: "-ms-2" } },
    { size: "sm", side: "end", class: { button: "-me-1" } },
    { size: ["default", "lg"], side: "end", class: { button: "-me-2" } }
  ],
  defaultVariants: {
    size: "default"
  }
});
export {
  numberFieldButtonVariants,
  numberFieldContentVariants,
  numberFieldInputVariants,
  numberFieldVariants
};
//# sourceMappingURL=index.js.map
